import React from "react";
import "./Spinner.css";

const Spinner = ({
  visible,
  style
}: {
  visible: boolean;
  style?: React.CSSProperties;
}) => (
  <span
    style={style}
    className={"PRZM-Spinner" + (visible ? " visible" : "")}
  />
);

export default Spinner;
